import React from 'react';
import {Typography} from '@mui/material';

export default function SchedulePlannerTitle({title}) {

    return (
      <Typography variant="h6" sx={{fontSize: '1rem', fontWeight: 'normal'}}>
          {title}
      </Typography>
    );
}